










































































































import { Component, Vue } from 'vue-property-decorator';
import { mdiCheckCircleOutline } from '@mdi/js';
import { esiaUrlEdit } from '@/app.config';
import { AuthModule } from '@/store/modules/auth';
import PersonProfileType from '@/components/profile/documents/types/PersonProfileType.vue';
import { isEmptyObject } from '@/utils/common';

// currentAddress - OPS
// registerAddress - OLG

@Component({
  components: { PersonProfileType },
  data: () => ({
    mdiCheckCircleOutline,
    isEmptyObject,
  }),
})
export default class OrganizationProfileType extends Vue {
  readonly avatar = false;

  get orgDetails() {
    return AuthModule.orgDetails;
  }

  get esiaUrlEdit() {
    return esiaUrlEdit;
  }
}
